import { useRoles } from "./RoleProvider";
import { MdmRole } from "./MdmRole";

export const useIsUserInRoles = (rolesToCheck: MdmRole[]): boolean => {
  const { roles } = useRoles();
  return rolesToCheck.some((role) => roles.includes(role));
};
